export default __webpack_public_path__ + "static/media/footer-mobile.54ed8df2.png";